// import {
//     Button,
//     Card,
//     Table,
//     TableBody,
//     TableCell,
//     TableFooter,
//     TableHead,
//     TableHeader,
//     TableRow,
// } from '@repo/shadcn';
// import { useFormContext } from 'react-hook-form';
//
// import { CreateSalesReturnForm } from '@/modules/sales-return/create-sales-return/schema';
// import { formatCurrencyInBDT } from '@/utils';
//
// import { useCreateSalesReturnContext } from './create-sales-return.context';
//
// export const Details = () => {
//     const { orderData, orderId, isLoading } = useCreateSalesReturnContext();
//
//     const { watch } = useFormContext<CreateSalesReturnForm>();
//
//     const items = watch('items');
//
//     const totalPrice = items.reduce(
//         (acc, item) => acc + item.price * item.quantity,
//         0,
//     );
//
//     if (isLoading) {
//         return (
//             <Card className={'p-4'}>
//                 <div className={'flex items-center justify-center py-6'}>
//                     Loading items...
//                 </div>
//             </Card>
//         );
//     }
//
//     if (!orderData || !orderId) {
//         return (
//             <Card className={'p-4'}>
//                 <div className={'flex items-center justify-center py-6'}>
//                     Please select an order to see details.
//                 </div>
//             </Card>
//         );
//     }
//
//     return (
//         <Card className={'p-4'}>
//             <div>
//                 <h2 className={'text-lg font-medium'}>Summary</h2>
//                 <div>
//                     <h3>Return Items</h3>
//                     <Table>
//                         <TableHeader>
//                             <TableRow>
//                                 <TableHead>Name</TableHead>
//                                 <TableHead className={'text-right'}>
//                                     Price
//                                 </TableHead>
//                                 <TableHead className="text-right">
//                                     Quantity
//                                 </TableHead>
//
//                                 <TableHead className="text-right">
//                                     Total
//                                 </TableHead>
//                             </TableRow>
//                         </TableHeader>
//                         <TableBody>
//                             {items.map((item) => (
//                                 <TableRow key={item.itemId}>
//                                     <TableCell>{item.productName}</TableCell>
//                                     <TableCell className={'text-right'}>
//                                         {formatCurrencyInBDT(item.price)}
//                                     </TableCell>
//                                     <TableCell className="text-right">
//                                         {item.quantity}
//                                     </TableCell>
//                                     <TableCell className={'text-right'}>
//                                         {formatCurrencyInBDT(
//                                             item.quantity * item.price,
//                                         )}
//                                     </TableCell>
//                                 </TableRow>
//                             ))}
//                         </TableBody>
//                         <TableFooter>
//                             <TableRow>
//                                 <TableCell colSpan={3}>Total</TableCell>
//                                 <TableCell className="text-right">
//                                     {formatCurrencyInBDT(totalPrice)}
//                                 </TableCell>
//                             </TableRow>
//                         </TableFooter>
//                     </Table>
//                 </div>
//             </div>
//             <div className={'flex items-center justify-end pt-4'}>
//                 <Button type={'submit'}>Confirm</Button>
//             </div>
//         </Card>
//     );
// };
//
// Details.displayName = 'Details';
import {
    Button,
    Card,
    Separator,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@repo/shadcn';
import { Loader2Icon } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { TextAreaField } from '@components/form/fields';

import { formatCurrencyInBDT } from '@/utils';

import { useCreateSalesReturnContext } from './create-sales-return.context';
import { CreateSalesReturnForm } from './schema';

export const SaleReturnOverview = () => {
    const { isOrderFetching, isOrderError, isOrderLoading } =
        useCreateSalesReturnContext();

    const { watch, formState } = useFormContext<CreateSalesReturnForm>();

    const { isValid } = formState;

    const items = watch('items');

    const selectedItems = items?.filter((item) => item.isSelected) || [];

    const totalAmount = selectedItems.reduce((acc, item) => {
        return acc + item.price * item.returnQuantity;
    }, 0);

    const isSubmitDisabled =
        !isValid || selectedItems.length === 0 || totalAmount <= 0;

    if (isOrderLoading || isOrderFetching) {
        return (
            <Card
                className={
                    'flex flex-col items-center justify-center gap-2 px-4 py-8'
                }
            >
                <Loader2Icon className={'animate-spin'} />
            </Card>
        );
    }

    if (isOrderError) {
        return (
            <Card className={'p-4 text-red-600'}>
                Error loading sales details.
            </Card>
        );
    }

    const renderItems = () => {
        if (!selectedItems || selectedItems.length === 0) {
            return (
                <p className={'p-4 text-center'}>
                    Check items to add for return.
                </p>
            );
        }

        return (
            <Table className={'px-0'}>
                <TableHeader>
                    <TableRow>
                        <TableHead className={'pl-0'}>Name</TableHead>
                        <TableHead className={'text-right'}>Price</TableHead>
                        <TableHead className="text-right">Quantity</TableHead>
                        <TableHead className="pr-0 text-right">Total</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody className={'px-0'}>
                    {selectedItems.map((item) => (
                        <TableRow key={item.itemId}>
                            <TableCell className={'pl-0'}>
                                {item.itemName}
                            </TableCell>

                            <TableCell className={'text-right'}>
                                {formatCurrencyInBDT(item.price)}
                            </TableCell>

                            <TableCell className="text-right">
                                {formatCurrencyInBDT(item.returnQuantity)}
                            </TableCell>

                            <TableCell className={'pr-0 text-right'}>
                                {formatCurrencyInBDT(
                                    item.price * item.returnQuantity,
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    };

    const renderFooter = () => {
        if (!selectedItems || selectedItems.length === 0) {
            return null;
        }
        return (
            <>
                <Separator />
                <div className={'flex items-end justify-end gap-4'}>
                    <strong>Total Amount: </strong>
                    <strong>{formatCurrencyInBDT(totalAmount)}</strong>
                </div>

                <div>
                    <label className={'mb-2 block font-medium'}>Reason</label>
                    <TextAreaField<CreateSalesReturnForm>
                        name={'reason'}
                        placeholder={'Enter return reason'}
                    />
                </div>

                <div className={'flex justify-end'}>
                    <Button type={'submit'} disabled={isSubmitDisabled}>
                        Submit
                    </Button>
                </div>
            </>
        );
    };

    return (
        <Card className={'space-y-4 p-4'}>
            <h3 className={'text-lg font-medium'}>Return Overview</h3>

            {renderItems()}
            {renderFooter()}
        </Card>
    );
};

SaleReturnOverview.displayName = 'SaleReturnOverview';
